import {view} from '@sail/ui';

import type {
  Conversation,
  ConversationLogItemMessageAdded,
} from '@stripe-internal/conversations-client';

import {rowForMessage} from './rowForMessage';

type Props = {
  conversation: Conversation;
  items: ConversationLogItemMessageAdded[];
  disableInteraction?: boolean;
  animated?: boolean;
};

export function GroupedMessagesRow({
  conversation,
  items,
  disableInteraction,
  animated,
}: Props) {
  if (items.length === 0) {
    return null;
  }

  const rows = items.map((item) =>
    rowForMessage({
      conversation,
      item,
      animated,
      disableInteraction,
    }),
  );

  return (
    <view.div
      className="uh-conversations-grouped-messages v1"
      data-testid="grouped-messages-row"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
        flex: 1,
      }}
    >
      {rows}
    </view.div>
  );
}
